import Dialog from './_dialog.js'
import ShareDialogFooter from './_share-dialog-footer.js'
import ShareBetSummary from './_share-bet-summary.js'
import FlexPane from './_flex-pane.js'
import BetLegsDetails from './_bet-legs-details.js'
import Image from './_image.js'
import Text from './_text.js'
import FormattedLabelWithTotalOdds from './_formatted-label-with-total-odds.js'

export default {
  name: 'ShareDialog',
  values: {
    dialog: {
      configSet: Dialog,
      configValues: {
        _mobile_layoutType: 'centered',
        allowScrolling: false,
        overlay: {
          style: {
            container: {
              _mobile_alignItems: 'flex-start',
            },
          },
        },
        centered: {
          width: 'calc(100% - 32px)',
          minWidth: '288px',
          minHeight: '320px',
          maxWidth: '440px',
          maxHeight: 'min(800px, 100%)',
          _mobile_maxHeight: '100%',
          height: 'auto',
          _mobile_padding: '88px 0 40px 0',
          _mobile_boxSizing: 'border-box',
        },
        header: {
          container: {
            style: {
              height: '48px',
            },
          },
        },
        contentContainer: {
          padding: '0px',
          height: 'calc(100% - 136px)',
        },
        closeButtonContainer: {
          style: {
            top: '-44px',
            right: '0px',
            _mobile_right: '0px',
            _mobile_top: '40px',
          },
        },
      },
    },
    dialogFooter: {
      configSet: ShareDialogFooter,
      configValues: {},
    },
    betSummary: {
      configSet: ShareBetSummary,
      configValues: {},
    },
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexBasis: 'auto',
          flexDirection: 'column',
          padding: '16px',
          overflow: 'auto',
        },
      },
    },
    betLegsDetails: {
      configSet: BetLegsDetails,
      configValues: {
        showBetLegNotification: false,
        showLegDateTime: false,
        showEventStartDateTime: false,
        matchAccaSelectionItem: {
          selectionIcon: {
            src: 'svg-sprites/generic/leg-status-open-icon.svg',
          },
          legStatusIcon: {
            open: {
              src: 'svg-sprites/generic/leg-status-open-icon.svg',
            },
            lost: {
              src: 'svg-sprites/generic/leg-status-lost-icon.svg',
            },
            void: {
              src: 'svg-sprites/generic/leg-status-void-icon.svg',
            },
            won: {
              src: 'svg-sprites/generic/leg-status-won-icon.svg',
            },
            cashedOut: {
              src: 'svg-sprites/generic/leg-status-cashed-out-icon.svg',
            },
          },
        },
        priceBoostIndicator: {
          indicationIcon: {
            src: 'share-bet/double-arrow-right-share-bet.svg',
          },
        },
        legStatusIcon: {
          open: {
            src: 'svg-sprites/generic/leg-status-open-icon.svg',
          },
          lost: {
            src: 'svg-sprites/generic/leg-status-lost-icon.svg',
          },
          void: {
            src: 'svg-sprites/generic/leg-status-void-icon.svg',
          },
          won: {
            src: 'svg-sprites/generic/leg-status-won-icon.svg',
          },
          cashedOut: {
            src: 'svg-sprites/generic/leg-status-cashed-out-icon.svg',
          },
        },
      },
    },
    logo: {
      configSet: Image,
      configValues: {
        style: {
          alignSelf: 'center',
          width: '104px',
        },
      },
    },
    betTypeOddsContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    betTypeName: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    betTypeContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'row',
          flexGrow: 0,
          alignItems: 'center',
        },
      },
    },
    totalOdds: {
      configSet: FormattedLabelWithTotalOdds,
      configValues: {
        priceBoostIndicator: {
          indicationIcon: {
            src: 'share-bet/double-arrow-right-share-bet.svg',
          },
        },
        container: {
          style: {
            justifyContent: 'center',
          },
        },
      },
    },
    betContentContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
          flexGrow: 0,
          padding: '8px',
          overflow: 'auto',
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
